// extracted by mini-css-extract-plugin
module.exports = {"url-to-svg":"UrlToSvg_url-to-svg__1ceNl"};